const state = {
  offerHistory: [],
  offerLoading: false,
  selectedOffer: null,
};

const getters = {
  offerHistory: (state) => state.offerHistory,
  offerLoading: (state) => state.offerLoading,
  selectedOffer: (state) => state.selectedOffer,
};

const actions = {
  getOfferHistory({ commit }) {
    commit('setOfferLoading', true);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('/offer/history')
        .then((response) => {
          commit('setOfferHistory', response.data.payload);
          resolve(response.data.payload);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit('setOfferLoading', false);
        });
    });
  },
  createOffer({ dispatch }, offerData) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/create', offerData)
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    });
  },
  acceptOffer({ dispatch }, offerId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/accept', { id: offerId })
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    });
  },
  declineOffer({ dispatch }, offerId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/decline', { id: offerId })
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    });
  },
  requestPayoutCard(context, payload) {
    console.log('Card payout payload:', payload);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/request-payout/card-form', payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data || 'Something went wrong');
        });
    });
  },
  requestPayoutIban(context, payload) {
    console.log('IBAN payout payload:', payload);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/request-payout/sepa-direct', payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data || 'Something went wrong');
        });
    });
  },
};

const mutations = {
  setOfferHistory(state, offerHistory) {
    state.offerHistory = offerHistory;
  },
  setOfferLoading(state, isLoading) {
    state.offerLoading = isLoading;
  },
  setSelectedOffer(state, offer) {
    state.selectedOffer = offer;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
